import * as React from 'react';

function SvgFilterUp(props) {
  return (
    <svg
      id="filter_up_svg__Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 7 20"
      xmlSpace="preserve"
      {...props}
    >
      <style>{'.filter_up_svg__st0,.filter_up_svg__st1{fill:#56e800}'}</style>
      <path
        id="filter_up_svg__XMLID_2_"
        className="filter_up_svg__st0"
        d="M3.9 19.5h-.8c-.2 0-.3-.1-.3-.3V3.3h1.5v15.8c-.1.2-.2.4-.4.4z"
      />
      <path
        id="filter_up_svg__XMLID_4_"
        className="filter_up_svg__st0"
        d="M5.2 6h1.7L3.6 1l-.9 1.2z"
      />
      <path
        id="filter_up_svg__XMLID_3_"
        className="filter_up_svg__st0"
        d="M1.9 6H.2l3.4-5 .8 1.2z"
      />
      <path
        id="filter_up_svg__XMLID_6_"
        className="filter_up_svg__st1"
        d="M3.9 19.5h-.8c-.2 0-.3-.1-.3-.3V3.3h1.5v15.8c-.1.2-.2.4-.4.4z"
      />
      <path
        id="filter_up_svg__XMLID_5_"
        className="filter_up_svg__st1"
        d="M5.2 6h1.7L3.6 1l-.9 1.2z"
      />
      <path
        id="filter_up_svg__XMLID_1_"
        className="filter_up_svg__st1"
        d="M1.9 6H.2l3.4-5 .8 1.2z"
      />
    </svg>
  );
}

export default SvgFilterUp;
